import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const PLACEHOLDER_CARDS = [
  { name: "Client 01", industry: "School", key: "c1" },
  { name: "Client 02", industry: "Café", key: "c2" },
  { name: "Client 03", industry: "Gym", key: "c3" },
];

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#08080a] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 lg:mb-16 lg:flex-row lg:items-end">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <div className="h-px w-8 bg-[var(--gold)]/60" />
              <span className="font-mono-label text-[var(--gold)]">
                07 · Success Stories
              </span>
            </div>
            <h2 className="font-display text-4xl leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
              The next success story<br />
              <span className="silver-gradient-text">could be yours.</span>
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-zinc-400">
            Our first client stories are currently being written. Yours might
            be next.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PLACEHOLDER_CARDS.map((c, idx) => (
            <motion.div
              key={c.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.6,
                delay: idx * 0.1,
                ease: [0.2, 0.8, 0.2, 1],
              }}
              className="relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0e0e10] p-7"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.14),transparent_60%)] blur-2xl" />
              <div className="flex items-center justify-between">
                <Quote className="h-6 w-6 text-[var(--gold-bright)]/60" />
                <span className="font-mono-label rounded-full border border-[var(--gold)]/30 bg-[var(--gold)]/[0.06] px-2.5 py-1 text-[9px] text-[var(--gold-bright)]">
                  Coming Soon
                </span>
              </div>
              <div className="mt-6 space-y-2">
                <div className="h-2.5 w-4/5 rounded-full bg-white/[0.05]" />
                <div className="h-2.5 w-3/5 rounded-full bg-white/[0.05]" />
                <div className="h-2.5 w-2/5 rounded-full bg-white/[0.05]" />
              </div>
              <div className="mt-8 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full border border-[var(--gold)]/25 bg-gradient-to-br from-[var(--gold)]/25 to-transparent" />
                <div>
                  <div className="text-[13px] font-medium text-white">
                    {c.name}
                  </div>
                  <div className="font-mono-label text-zinc-500">
                    {c.industry}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
